import {View, Text} from 'react-native';
import React from 'react';
import {styles} from './styles';
import {Image} from 'react-native';
import {Images} from '../../constants/Images';

interface IToast {
  title?: string;
  error?: boolean;
}

const Toast = ({title, error}: IToast) => {
  return (
    <View style={[styles.toast, error && styles.errorToast]}>
      {Images.checkToast && (
        <Image source={Images.checkToast} style={styles.check} />
      )}
      <Text style={styles.toastText}>{title}</Text>
    </View>
  );
};

export default Toast;
